function AddVehicleBookingController() {
    this.constructor.apply(this, arguments);
}

AddVehicleBookingController.$inject = ['$state', '$stateParams', 'CacheMemoryService'];
AddVehicleBookingController.prototype = {
    /**
     *
     * @param $state {ui.IStateService}
     * @param $stateParams {ui.IStateParamsService}
     * @param cacheMemoryService {CacheMemoryService}
     */
    constructor($state, $stateParams, cacheMemoryService) {
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.cacheMemoryService = cacheMemoryService;
        // Init StartDate, Enddate
        var startDate = moment().startOf('isoWeek').format('YYYY-MM-DD');
        if (this.$stateParams.startDate) {
            startDate = moment(this.$stateParams.startDate, "YYYY-MM-DD").startOf('isoWeek').format('YYYY-MM-DD');
        }
        this.startDate = startDate;
        this.endDate = moment(this.startDate).add(6, 'days').format('YYYY-MM-DD');
    },
    /**
     * Goback Vehicle Bookings page
     */
    goBack() {
        this.cacheMemoryService.remove('GetAvailableVehicles');
        this.cacheMemoryService.remove('getAllBookings');
        this.$state.go('internal.vehiclebookings');
    }
}


angular.module('internal.vehiclebookings').controller('AddVehicleBookingController', AddVehicleBookingController);
